<template>
  <div class="share-row-container">
    <div class="icon">
      <slot name="icon" />
    </div>
    <div class="title">
      <div class="text-subtitle-1">
        {{ title }}
      </div>
      <slot name="subtitle" />
    </div>
    <div class="options">
      <v-select
        v-if="roleOptions && !disabled"
        v-model="roleValue"
        :items="roleOptions"
        variant="plain"
        class="options__select"
        density="compact"
        flat
        @update:model-value="$emit('updateRole', $event)"
        @mouseenter="highlightDropdown($event)"
        @mouseleave="removeHighlightDropdown($event)"
      />
      <span
        v-else
        class="text-subtitle-1"
        :style="{ 'margin-right': disabled ? '30px' : '0px' }"
      >
        {{ roleValue }}
      </span>
      <TrashIcon
        v-if="deleteable && !disabled"
        class="options__icon"
        @click.stop="!disabled ? $emit('removeUser') : null"
      />
    </div>
  </div>
</template>

<script>
import TrashIcon from '@/components/svgs/TrashIcon.vue';

export default {
  components: {
    TrashIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    deleteable: {
      type: Boolean,
      required: false,
      default: false,
    },
    roleOptions: {
      type: Array,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['removeUser', 'updateRole'],
  data() {
    return {
      roleValue: this.role,
    };
  },
  computed: {
    fontColor() {
      return this.disabled ? 'gray' : '$npGray';
    },
  },
  methods: {
    highlightDropdown(event) {
      if (!this.disabled) {
        event.target.classList.add('highlighted');
      }
    },
    removeHighlightDropdown(event) {
      if (!this.disabled) {
        event.target.classList.remove('highlighted');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.share-row-container {
    cursor: default;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .title {
      display: flex;
      flex: 0.97;
      flex-direction: column;
    }
    .options {
      color: v-bind(fontColor);
      display: flex;
      align-items: center;
      justify-content: center;

      &__icon {
        cursor: pointer;
        display: flex;
        margin-right: 6px;
        margin-left: 12px;
        margin-bottom: 1px;
      }

      &__select {
        :deep(.v-select__selection-text) {
          color: main.$npGray;
        }
        :deep(.v-input__control) {
          padding-bottom: 10px;
          padding-left: 10px;
        }
        :deep(.v-icon) {
          margin-left: 0px;
          margin-right: 2px;
        }
      }
    }
}
.highlighted {
  :deep(.v-input__control) {
    background-color: rgba(151, 151, 151, 0.1);
  }
}
</style>
